export default __webpack_public_path__ + "static/media/Ellipse 74.cca97410.svg";